//react
import React, { Component } from 'react';

//assets
import './translation.css';

//functions
import * as Utilities from '../../utilities';

class Translation extends Component {
	render() {
		const data = this.props.data;
		const cultureFallback = 'uk'; //UK set as the default culture
		let cultureRequested = cultureFallback;
		let translation = null;

		if (data) {
			//get culture if one requested
			if (this.props.culture) {
				if (data[this.props.culture]) {
					cultureRequested = this.props.culture;
				}
			}

			//get translation for requested culture
			if (data[cultureRequested][this.props.name]) {
				translation = data[cultureRequested][this.props.name];
			}

			//if no translation for requested culture get translation for fallback culture
			if (!translation) {
				if (data[cultureFallback][this.props.name]) {
					translation = data[cultureFallback][this.props.name];
				}
			}
		}

		//if no translation set warning message
		if (!translation) {
			translation = '[TRANSLATION NOT FOUND]';
		}

		//if html then output in translation block
		if (this.props.html) {
			return (
				<div className="translation-block" dangerouslySetInnerHTML={{__html: translation}} />
			);
		}

		return (
			<span>{Utilities.removeWidow(translation)}</span>
		);
	}
}

export default Translation;



// WEBPACK FOOTER //
// ./src/components/translation/translation.js